import { render, staticRenderFns } from "./establishEnclosure.vue?vue&type=template&id=523e4740&scoped=true&"
import script from "./establishEnclosure.vue?vue&type=script&lang=js&"
export * from "./establishEnclosure.vue?vue&type=script&lang=js&"
import style0 from "./establishEnclosure.vue?vue&type=style&index=0&id=523e4740&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e4740",
  null
  
)

export default component.exports